export function getFileNameFromContentDisposition(header: string | null): string {
  if (!header) return 'download.pdf';

  const matches = header.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
  const extracted = matches && matches[1] ? matches[1].replace(/['"]/g, '') : null;

  return extracted ? extracted.replace(/\.pdf$/i, '') + '.pdf' : 'download.pdf';
}
